export function getPorezniZakoni(porezniZakoni) {
    return { type: 'GET_POREZNI_ZAKONI', porezniZakoni };
}
